
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"35","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.994 11.951a.676.676 0 00-.167-.429L28.39 4.377a.79.79 0 00-.497-.224h-7.718L16.82.424A.788.788 0 0016.314.2H4.094A3.898 3.898 0 00.2 4.093V25.95a3.895 3.895 0 003.894 3.893h7.684a3.899 3.899 0 003.895 3.957h15.431A3.9 3.9 0 0035 29.907c0-.021.004-17.939-.005-17.956zm-6.424-5.35l4.229 4.697h-2.336a1.897 1.897 0 01-1.893-1.893V6.6zM16.992 2.645l4.23 4.698h-2.336a1.898 1.898 0 01-1.894-1.894V2.645zM1.557 25.95V4.092a2.538 2.538 0 012.537-2.536h11.542v3.892a3.253 3.253 0 003.25 3.25h3.182V25.95a2.54 2.54 0 01-2.538 2.536H4.094a2.54 2.54 0 01-2.537-2.537v.001zm29.547 6.493H15.673a2.544 2.544 0 01-2.538-2.6h6.395a3.9 3.9 0 003.894-3.893V8.02a.76.76 0 00-.174-.453L21.397 5.51h5.815v3.895a3.252 3.252 0 003.25 3.25h3.179v17.252a2.54 2.54 0 01-2.538 2.537z","fill":"#fff"}})])
          )
        }
      }
    